// @flow

import _ from 'lodash';
import gql from 'graphql-tag';

import { graphql } from '@apollo/react-hoc';

import SplitLoginPage from 'app/login/components/SplitLoginPage';
import maybeRender from 'app/common/components/maybeRender';
import { enableSentryRequestLogging } from 'app/common/middlewares/sentryErrorsMiddleware';

type OwnProps = {
  selectedApis: Array<string>,
};

const oneServiceSplitLoginPageQuery = gql`
  query oneServiceSplitLoginPageQuery($headImplementationId: ID!) {
    headService: appImplementationById(id: $headImplementationId) {
      id
      key: id
      name
    }
  }
`;

export default _.flowRight(
  graphql(oneServiceSplitLoginPageQuery, {
    options: (props: OwnProps) => {
      const { selectedApis } = props;
      const s1 = selectedApis[0];

      return {
        variables: enableSentryRequestLogging({
          headImplementationId: s1,
        }),
      };
    },
  }),
  maybeRender(props => !props.data.loading)
)(SplitLoginPage);
